import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  setdarkTheme,
  setsidebarActive,
} from "../../redux/features/stylesSlice";
import BookmarksOutlinedIcon from "@mui/icons-material/BookmarksOutlined";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import SearchBarPrimary from "../../components/searchbar/SearchBarPrimary";
import MenuPrimary from "../../components/menu/MenuPrimary";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import LightModeIcon from "@mui/icons-material/LightMode";
import { logoutUser } from "../../redux/features/authSlice";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyIcon from "@mui/icons-material/Key";
import PeopleIcon from "@mui/icons-material/People";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import MenuIcon from "@mui/icons-material/Menu";
import { initAmplitude } from "../../functions/amplitude";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import FunctionsIcon from "@mui/icons-material/Functions";
import EditIcon from "@mui/icons-material/Edit";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import {
  setChangeEmailPopup,
  setCitationPopup,
  setMicrosoftUser,
  setSummarizePopup,
  setSummaryPopup,
  setsearch,
} from "../../redux/features/dataSlice";
import PopupUserInvite from "../popup/PopupUserInvite";
import PopupChangeEmail from "../popup/PopupChangeEmail";
import { Tooltip } from "@mui/material";
import PopupInfoDiet from "../popup/PopupInfoDiet";
import SettingsIcon from "@mui/icons-material/Settings";
import Avatar from "../popup/PopupInfoDiet/Avatar";
import { useMsal } from "@azure/msal-react";

const Navbar = () => {
  const [userInvite, setUserInvite] = useState(false);
  const [showInfoDietPopup, setShowInfoDietPopup] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { sidebarActive } = useSelector((state) => state.styles);

  const { instance } = useMsal();

  const { darkTheme } = useSelector((state) => state.styles);
  const { user } = useSelector((state) => state.auth);
  const { search, summaryPopup, changeEmailPopup, microsoftUser } = useSelector(
    (state) => state.data
  );
  const [customSearch, setCustomSearch] = useState();

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    initAmplitude(user.userId);
    if (theme) {
      document.body.classList.add(theme);
      dispatch(setdarkTheme(true));
    }
  }, []);

  const handleLogout = () => {
    if (microsoftUser) handleLogoutMicrosoft();

    if (sessionStorage.getItem("user")) {
      sessionStorage.removeItem("user");
    } else {
      localStorage.removeItem("user");
    }
    window.location.href = "/signin";

    dispatch(logoutUser());
  };

  useEffect(() => {
    if (darkTheme) {
      document.body.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark");
      localStorage.removeItem("theme");
    }
  }, [darkTheme]);

  useEffect(() => {
    dispatch(setSummarizePopup(false));
    dispatch(setCitationPopup(false));
  }, [pathname]);

  const handleLogoutMicrosoft = () => {
    if (instance) {
      sessionStorage.clear();
    } else {
      console.error("MSAL instance is not available.");
    }
  };

  return (
    pathname !== "/change-password" &&
    pathname !== "/signin/clever" && (
      <div
        className={`navbar${sidebarActive ? " sidebar-active" : ""} ${
          pathname !== "/" ? "bg-img" : ""
        }`}
        style={{
          backgroundColor: pathname === "/" ? "transparent" : "",
          color: pathname === "/" ? "#fff" : "",
        }}
      >
        {pathname !== "/" && (
          <div className="nav-left">
            {pathname.includes("/search") && (
              <div
                className="sidebar-toggle hd-ds"
                onClick={() => dispatch(setsidebarActive(!sidebarActive))}
              >
                <MenuIcon />
              </div>
            )}
            <Link
              onClick={() => {
                dispatch(setsearch(customSearch));
                console.log("");
              }}
              to="/"
              className="logo"
            >
              Sooth<span>.</span>
            </Link>
          </div>
        )}
        {pathname !== "/" && (
          <div className="nav-middle">
            <SearchBarPrimary
              placeholder="Start Researching..."
              results={[]}
              onFocus={() => null}
              customSearch={customSearch}
              setCustomSearch={setCustomSearch}
            />
            <div className="flex" style={{ gap: "5rem", textAlign: "center" }}>
              <button
                className={`mt-1 flex menu-button ${
                  pathname.includes("/books/") ? "click" : ""
                }`}
              >
                {" "}
                <div
                  className="menu-button-gap"
                  onClick={() => {
                    search
                      ? window.open(
                          `/books/${encodeURIComponent(customSearch)}`
                        )
                      : navigate(`/books/usa`);
                  }}
                >
                  <div className="flex menu-button-gap ">
                    {<MenuBookIcon />}
                    <p>Books</p>
                  </div>
                </div>
              </button>
              <button
                className={`mt-1 flex menu-button ${
                  pathname.includes("/wiki/") ? "click" : ""
                }`}
              >
                <div
                  className="menu-button-gap"
                  onClick={() => {
                    search
                      ? window.open(`/wiki/${encodeURIComponent(customSearch)}`)
                      : navigate(`/wiki/usa`);
                  }}
                >
                  <div className="flex menu-button-gap">
                    {<LibraryBooksIcon />}
                    <p> Encyclopedia & Dictionary </p>
                  </div>
                </div>
              </button>
              {
                <button
                  className={`mt-1 flex menu-button ${
                    summaryPopup ? "click" : ""
                  }`}
                >
                  <div
                    className="menu-button-gap"
                    onClick={() => dispatch(setSummaryPopup((prev) => !prev))}
                  >
                    <div className="flex menu-button-gap">
                      {<FunctionsIcon />}
                      <p> Summarizer</p>
                    </div>
                  </div>
                </button>
              }
            </div>
          </div>
        )}

        <div className="nav-right">
          {user.roles.includes("Admin") && (
            <Link
              to="/admin"
              className="tab"
              target={pathname.includes("search") ? "_blank" : "_self"}
            >
              <PeopleIcon />
            </Link>
          )}
          <Link
            to="/saved/0"
            className="tab"
            target={pathname.includes("search") ? "_blank" : "_self"}
          >
            <Tooltip title="Open my Collections">
              <BookmarksOutlinedIcon />
            </Tooltip>
          </Link>

          <MenuPrimary
            data={[
              {
                name: darkTheme ? "Light Theme" : "Dark Theme",
                icon: darkTheme ? <LightModeIcon /> : <NightsStayIcon />,
                onClick: () => dispatch(setdarkTheme(!darkTheme)),
              },
              {
                name: "Invite a friend",
                icon: <PersonAddIcon />,
                onClick: () => {
                  setUserInvite(true);
                },
              },
              {
                name: "My Info Diet",
                icon: <ShowChartIcon />,
                onClick: () => {
                  setShowInfoDietPopup(true);
                },
              },
              {
                name: "Edit Profile",
                icon: <EditIcon />,
                onClick: () => {
                  navigate("/settings");
                },
              },
              {
                name: "Logout",
                icon: <LogoutIcon />,
                onClick: () => {
                  dispatch(setsearch(""));
                  handleLogout();
                },
              },
            ]}
            children={
              <Tooltip title="My Account">
                <div className="flex">
                  <Avatar
                    name={localStorage.getItem("email")}
                    size="3rem"
                    fontSize="1.5rem"
                    profile={true}
                  />
                  <KeyboardArrowDownOutlinedIcon />
                </div>
              </Tooltip>
            }
          />
        </div>
        {userInvite && (
          <PopupUserInvite
            showPopup={userInvite}
            setShowPopup={setUserInvite}
          />
        )}
        {changeEmailPopup && <PopupChangeEmail showPopup={changeEmailPopup} />}
        {showInfoDietPopup && (
          <PopupInfoDiet
            showInfoDietPopup={showInfoDietPopup}
            setShowInfoDietPopup={setShowInfoDietPopup}
          />
        )}
      </div>
    )
  );
};

export default Navbar;
